'use strict';

var app = angular.module('amexReconciliationApp');
app.controller('ConfirmationPopoverController', function(
  $scope, $element, $compile, $document, $window, $uibPosition) {
  var self = this;

  this.defaults = {
    confirmText: 'Yes',
    cancelText: 'No',
    confirmButtonType: 'default',
    cancelButtonType: 'default',
    placement: 'top',
    onCancel: function () {}
  };

  this.popoverPlacement = this.placement || this.defaults.placement;

  var template = [
    '<div class="popover" ng-class="ctrl.popoverPlacement">',
    '<div class="arrow"></div>',
    '<h3 class="popover-title" ng-bind-html="ctrl.title"></h3>',
    '<div class="popover-content">',
    '<p ng-bind-html="ctrl.message" ng-show="ctrl.message"></p>',
    '<a class="btn btn-sm btn-default mrs btn-confirm" ng-click="ctrl.onConfirm(); ctrl.hidePopover()" title="{{ctrl.confirmText || ctrl.defaults.confirmText}}" ng-bind-html="ctrl.confirmText || ctrl.defaults.confirmText"></a>',
    '<a class="inverse-link btn-cancel" ng-click="ctrl.onCancel(); ctrl.hidePopover()" title="{{ctrl.cancelText || ctrl.defaults.cancelText}}" ng-bind-html="ctrl.cancelText || ctrl.defaults.cancelText"></a>',
    '</div>',
    '</div>'
  ].join('\n');

  var popover = angular.element(template);
  popover.css('display', 'none');
  $compile(popover)($scope);
  $document.find('body').append(popover);

  this.isVisible = false;

  function positionPopover() {
    var position = $uibPosition.positionElements($element, popover, self.popoverPlacement, true);
    position.top += 'px';
    position.left += 'px';
    popover.css(position);
  }

  function showPopover() {
    if (!self.isVisible) {
      popover.css({display: 'block'});
      positionPopover();
      self.isVisible = true;
    }
  }

  function hidePopover() {
    if (self.isVisible) {
      popover.css({display: 'none'});
      self.isVisible = false;
    }
  }

  function togglePopover() {
    if (!self.isVisible) {
      showPopover();
    } else {
      hidePopover();
    }
  }

  function documentClick(event) {
    if (self.isVisible && !popover[0].contains(event.target) && !$element[0].contains(event.target)) {
      hidePopover();
    }
  }

  this.showPopover = showPopover;
  this.hidePopover = hidePopover;
  this.togglePopover = togglePopover;

  $element.bind('click', togglePopover);

  $window.addEventListener('resize', positionPopover);

  $document.bind('click', documentClick);
  $document.bind('touchend', documentClick);

  $scope.$on('$destroy', function() {
    popover.remove();
    $element.unbind('click', togglePopover);
    $window.removeEventListener('resize', positionPopover);
    $document.unbind('click', documentClick);
    $document.unbind('touchend', documentClick);
  });

});

app.directive('confirmationPopover', function() {

  return {
    restrict: 'EA',
    controller: 'ConfirmationPopoverController as ctrl',
    bindToController: true,
    scope: {
      confirmText: '@',
      cancelText: '@',
      message: '@',
      title: '@',
      placement: '@',
      onConfirm: '&',
      onCancel: '&'
    }
  };

});



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/confirmationPopover.js
// module id = 519
// module chunks = 0